import parse from 'html-react-parser';
import css from './ProductMain.module.scss';
import ProductSlider from './components/ProductSlider/ProductSlider';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import SingleButton from '../../../../../widgets/form/form-control-buttons/SingleButton/SingleButton';
import T from '../../../../../common/components/T';
import SocialShare from '../../../../../hybrid/library/SocialShare/SocialShare';
import { replaceUrl } from '../../../../../common/utils/router';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import RelatedProducts from './components/RelatedProducts/RelatedProducts';
import MainProperties from './components/MainProperties/MainProperties';
import { getProductProperties } from './helpers';
import CartCounter from '../../../../../widgets/cart/CartCounter/CartCounter';
import { checkBrowser } from '../../../../../common/utils/utils';
import { useWindowDimensions } from '../../../../../common/utils/windowDimensions';
import UserContext from '../../../../../common/utils/getContext';

export default function ProductMain({ dataProduct, funcs, translates }) {
    const { userToken } = useContext(UserContext);
    const router = useRouter();
    // const [reviewsData, setReviewsData] = useState(reviews);
    const sliderImages = useMemo(
        () => [dataProduct?.image, ...(dataProduct?.images || []), ...(dataProduct?.videos || [])].filter((img) => Boolean(img)),
        [dataProduct]
    );

    const [properties, setProperties] = useState({});

    useEffect(() => {
        getProductProperties(dataProduct, setProperties, translates);
    }, [dataProduct, translates]);
    const isAvailable = dataProduct?.product_availability !== 'not_in_stock';

    const rightBlockRef = useRef();
    const centralBlockRef = useRef();

    const width = useWindowDimensions();

    useEffect(() => {
        if (rightBlockRef.current) {
            const elem = rightBlockRef.current;
            const parent = elem.parentElement;
            const elemPOS = elem.getBoundingClientRect();
            const parentPOS = parent.getBoundingClientRect();
            const listener = () => {
                if (checkBrowser(parentPOS.height) - checkBrowser(elemPOS.height) - checkBrowser(window.scrollY) < 0) {
                    elem.style.transform = `translateY(${checkBrowser(parentPOS.height) - checkBrowser(elemPOS.height)}px)`;
                } else {
                    elem.style.transform = `translateY(${checkBrowser(window.scrollY)}px)`;
                }
            };
            listener();
            document.addEventListener('scroll', listener);
            return () => {
                document.removeEventListener('scroll', listener);
            };
        }
    }, [rightBlockRef?.current, width]);

    useEffect(() => {
        if (centralBlockRef.current) {
            const elem = centralBlockRef.current;
            const parent = elem.parentElement;
            const elemPOS = elem.getBoundingClientRect();
            const parentPOS = parent.getBoundingClientRect();
            const listener = () => {
                if (checkBrowser(parentPOS.height) - checkBrowser(elemPOS.height) - checkBrowser(window.scrollY) < 0) {
                    elem.style.transform = `translateY(${checkBrowser(parentPOS.height) - checkBrowser(elemPOS.height)}px)`;
                } else {
                    elem.style.transform = `translateY(${checkBrowser(window.scrollY)}px)`;
                }
            };
            listener();
            document.addEventListener('scroll', listener);
            return () => {
                document.removeEventListener('scroll', listener);
            };
        }
    }, [centralBlockRef?.current, width]);

    return (
        <div className={css.bgContainer}>
            <div className={css.wrapper}>
                <h1 className={css.lightTitle}>{dataProduct?.name}</h1>
                <div className={css.content}>
                    <div className={css.info}>
                        <p className={css.title}>{dataProduct?.name}</p>
                        {dataProduct?.description && typeof dataProduct?.description === 'string' ? (
                            <div className={css.description}>{parse(dataProduct?.description)}</div>
                        ) : null}
                        <MainProperties setProperties={setProperties} properties={properties} dataProduct={dataProduct} />
                    </div>
                    <div ref={width < 1200 ? null : centralBlockRef} className={css.slider}>
                        <ProductSlider sliderImages={sliderImages} dataProduct={dataProduct} />
                    </div>
                    <div ref={width < 1200 ? null : rightBlockRef} className={css.actionsWrapper}>
                        <div className={css.price}>
                            <p className={classNames(css.priceValue, { [css.priceMargin]: properties?.right?.length === 0 })}>
                                {dataProduct?.price?.price_for_currency_formatted}
                            </p>
                            {userToken ? <p className={css.pvPrice}>{dataProduct?.price?.price_for_client_formatted}</p> : null}
                        </div>
                        <table className={classNames(css.table, { [css.dn]: properties?.right?.length === 0 })}>
                            {properties?.right ? (
                                <tbody>
                                    {properties?.right?.map((property) => (
                                        <tr className={css.property} key={property.id}>
                                            <td className={css.propertyTitle}>
                                                {typeof property?.title === 'object' ? (
                                                    <>{property.title}:</>
                                                ) : property?.title ? (
                                                    property?.title + ':'
                                                ) : (
                                                    '-'
                                                )}
                                            </td>
                                            <td className={css.propertyValue}>
                                                {property?.type === 'float' ? parseFloat(property?.value) : property?.value}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            ) : null}
                        </table>
                        <div className={css.actions}>
                            {isAvailable ? (
                                <>
                                    <div className={css.counter}>
                                        <CartCounter
                                            customCss={{
                                                cartItemCounterValue: css.cartItemCounterValue,
                                                cartItemCounter: css.cartItemCounter,
                                                cartItemCounterCircle: css.cartItemCounterCircle
                                            }}
                                            idProduct={dataProduct.id}
                                            autoCounter={true}
                                        />
                                    </div>
                                    <div className={css.actionsRight}>
                                        <SingleButton
                                            type='ok'
                                            buttonText={<T textName='add-to-cart-v1' defaultStr='В корзину' />}
                                            clickFunc={funcs?.add}
                                            customButton={{
                                                butWrapper: css.addBtn,
                                                singleButton: css.addBtnWrap
                                            }}
                                        />
                                        <div className={classNames('circleButton', css.socialShare)}>
                                            <SocialShare
                                                compCss={{ icon: css.socialShareIcon }}
                                                val={replaceUrl(`/store/product/${dataProduct.id}`, router)}
                                                addRef={false}
                                            />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <p>{dataProduct?.product_availability_translated}</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className={css.relatedProducts}>
                <RelatedProducts dataProduct={dataProduct} />
            </div>
        </div>
    );
}
